import React from 'react';
import { BoneIcon } from 'lucide-react';
import { collectionChecklist } from '../data/content';
import { CheckItem } from './CheckItem';
export function ProductIntro() {
  return <section className="bg-white px-4 py-6 text-center md:px-12 md:py-8" data-id="element-176" data-mp="1noe8cbtezem8">
      <h2 className="mx-auto max-w-[620px] font-heading text-[19px] font-extrabold uppercase leading-[1.2] tracking-[-0.2px] text-navy md:text-[24px]" data-id="element-177" data-mp="1nq8t9q4or6qb">
        The complete 6-in-1 orthopedic clinical resource system
      </h2>
      <p className="mt-1.5 font-heading text-[24px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-brand md:text-[34px]" data-id="element-178" data-mp="2lbn18rvqvpy9">
        <BoneIcon className="mr-2 inline h-6 w-6 -translate-y-1 text-gold md:h-8 md:w-8" strokeWidth={2.5} aria-hidden data-id="element-179" data-mp="26m8rvjs658iv" />
        Complete Orthopedic &amp; Trauma Toolkit™
      </p>
      <p className="mt-1.5 font-heading text-[12px] font-bold uppercase leading-tight tracking-[0.06em] text-goldDark md:text-[13px]" data-id="element-180" data-mp="2zbflq5goh9xs">
        Advanced practical resources for orthopedic surgeons &amp; trauma specialists
      </p>
      <p className="mx-auto mt-1 max-w-[600px] text-[13px] leading-[1.35] text-ink md:text-[14px]" data-id="element-181" data-mp="ug6wmkhd8j4a">
        Clinical Assessment • Differential Diagnosis • Complex Trauma • Orthopedic Conditions • Treatment Planning •
        Complications &amp; Follow-Up
      </p>
      <p className="mt-1 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-182" data-mp="zei1shwpu5g6">
        6 Advanced Clinical Volumes + 5 FREE Professional Bonuses
      </p>

      <h3 className="mt-4 font-heading text-[15px] font-extrabold uppercase leading-tight text-navy md:text-[17px]" data-id="element-183" data-mp="187bvvlgtn9e3">
        The collection includes
      </h3>
      <ul className="mt-2.5 grid gap-x-6 gap-y-1 text-left text-[14px] leading-[1.35] text-ink sm:grid-cols-2 md:text-[15px]" data-id="element-184" data-mp="1n3kt6hh5jcnv">
        {collectionChecklist.map(item => <CheckItem key={item} data-id="element-185" data-mp="3owigjxs5td1f">{item}</CheckItem>)}
      </ul>

      <div className="mt-4 border-t border-line pt-3" data-id="element-186" data-mp="3jx5u3e57a7zd">
        <p className="font-heading text-[18px] font-extrabold uppercase leading-tight text-navy md:text-[22px]" data-id="element-187" data-mp="3jypd3ci8qx4u">
          11 professional resources. 440 pages.
        </p>
        <p className="mt-1 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[14px]" data-id="element-188" data-mp="hhqweh6ayh3g">
          Planned practical material in one organized collection
        </p>
      </div>
    </section>;
}